var _ = require('lodash');

module.exports = {
	_input_newValue: function(new_value){
		var onChange = this.props.onChange;
		if(_.isFunction(onChange)){
			onChange(this.props.field_path, new_value);
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/FormInputMixin.js
// module id = 38
// module chunks = 0 1 2 3 4